import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { JWTService } from './JWTService';
import { HangHoa } from '../models/product.model';
import { QuayBanCuaHang } from '../models/store_stalls.model';
import { ServerResponse } from '../models/types';
import * as localForage from 'localforage';
import { GetLocalForageConFigService } from './getLocalForage.service';
import { async } from 'q';

@Injectable()
export class ProductService {
  dsHangHoa: Array<HangHoa> = new Array<HangHoa>();
  url: any;
  constructor(
    private http: HttpClient,
    private storeHH: Store<QuayBanCuaHang>,
    private jwtService: JWTService,
    private getlocalconfig: GetLocalForageConFigService,
    @Inject('BASE_URL') baseUrl: string,
  ) {
    this.url = baseUrl;
  }

   async getProduct(value: string) {
    return this.http.post(this.url + 'api/Product/getProduct', { MaKhuVuc: value })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          // const reader = new XMLHttpRequest();
          this.dsHangHoa = result[0].data;
          //console.log(this.dsHangHoa);

          this.storeHH.dispatch({ type: 'INIT_HangHoa', hh: this.dsHangHoa });
          const str = this.jwtService.enCryptData(this.dsHangHoa);
          this.getlocalconfig.getConfigLocalForage()
            .then(async res => {
              await localForage.setItem('_dsHH', str);
            });
          console.log('getProduct');
          return Promise.resolve(this.dsHangHoa);
        } else {
          return Promise.reject(null);
        }
      });
  }

  async setNewPrice(MaHH: string, GiaMoi: number) {
    await localForage.getItem('_dsHH').then((result: string) => {
      const deCryptDSHH = this.jwtService.deCryptData(result);
      const danhsachHangHoa: Array<HangHoa> = JSON.parse(deCryptDSHH);
      // danhsachHangHoa.forEach(element => {
      //   productService.getImgProduct(element.MaHH).then(data => element.HinhAnh = data);
      // });
      const objIndex = danhsachHangHoa.findIndex((obj => obj.MaHH == MaHH));
      danhsachHangHoa[objIndex].GiaBanLe = GiaMoi;
      const str = this.jwtService.enCryptData(danhsachHangHoa);
      this.getlocalconfig.getConfigLocalForage()
        .then(async res => {
          await localForage.setItem('_dsHH', str);
        }).catch(async err => {
          return Promise.reject(null);
        });
      return Promise.resolve();
    });
  }

  async getImgProduct(value) {
    const img = value + '.jpg';
    const image = new Image();
    image.src = 'assets/images/Products/' + img;
    if(!image.complete)
    { 
      return Promise.resolve(false);
    }
    else if( image.height === 0)
    {
      return Promise.resolve(false);
    }
    else
    {
      return Promise.resolve(true);
    }

    // return this.http.get('assets/images/Products/' + img, { responseType: 'text' })
    //   .toPromise()
    //   .then(data => {
    //     if (data.match('html')) {
    //       return Promise.resolve(false);
    //     }
    //     return Promise.resolve(true);
    //   })
    //   .catch(err => {
    //     return Promise.resolve(false);
    //   });

  }

  async check_force_update(): Promise<boolean>{
    var rest = undefined;
    await localForage.getItem('_updItems').then((result: string) => {
      if (result != null) {
    var checks = result.toLowerCase() == 'true';
        rest = checks;
        if (checks != null) {
          if (checks == true) {
            var MaCH = "";
            const getState: QuayBanCuaHang = JSON.parse(localStorage.getItem('_dtQBan'));
            if (getState) {
              console.log(getState[0]);
              const qban = getState[0];
              MaCH = qban.MaCH;
              this.getProduct(MaCH).then(res => {
                localForage.removeItem('_updItems');
                return rest;
              })
                .catch(async err => {
                  return Promise.reject(null);
                });
            }
          }
        }
      }
    });
    return rest;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/product.service.ts